module.exports = __webpack_public_path__ + "static/img/detail1.b9986359.png";